export default {
  methods: {
    jumpUrl (banner) {
      if (banner.jumpUrl) {
        window.location.href = banner.jumpUrl
      }
    }
  }
}